import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "app-cbta-other-comments-modal",
	templateUrl: "./cbta-other-comments-modal.component.html",
	styleUrls: ["./cbta-other-comments-modal.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaOtherCommentsModalComponent implements OnInit {
	otherCommentsForm!: UntypedFormGroup;
	@Input() maneuver = "";
	@Input() otherComment = "";
	@Input() commentAiAssist = false;
	@Output() otherCommentsValue: EventEmitter<any> = new EventEmitter<any>();
	@Output() replaceSave = new EventEmitter<void>();

	constructor(private fb: UntypedFormBuilder) {}

	ngOnInit(): void {
		this.otherCommentsForm = this.fb.group({
			otherComents: [this.otherComment, []],
		});

		this.otherCommentsValue.emit({
			otherComents: this.otherComentsVal?.value,
		});

		this.otherCommentsForm.get("otherComents")?.valueChanges.subscribe(() => {
			this.otherCommentsValue.emit({
				otherComents: this.otherComentsVal?.value,
			});
		});
	}

	get otherComentsVal() {
		return this.otherCommentsForm.get("otherComents");
	}

	commentLengthLabel(length: number): string {
		return this.commentAiAssist ? `(${length})` : `(${length} / 500)`;
	}

	getCommentMaxLength(): number | null {
		return this.commentAiAssist ? null : 500;
	}

	onReplaceSave(): void {
		this.otherCommentsValue.emit({
			otherComents: this.otherComentsVal?.value,
		});
		this.replaceSave.emit();
	}
}
